// Actions
import { changeLocalLoading, changeErr, changeSuccess } from "../App/actions";

// Axios
import { serverAPI } from "../../index";

// Action types
export const RESET_PASSWORD = "reset_password";

export function resetPassword(data) {
  return function (dispatch) {
    dispatch(changeLocalLoading(true));
    return serverAPI
      .put("/user/reset-password", data)
      .then((response) => {
        dispatch(changeLocalLoading(false));
        dispatch(changeSuccess('Senha redefinida. Você será redirecionado para a página de login em instantes.'));
        return response;
      })
      .catch((e) => {
        dispatch(changeLocalLoading(false));
        switch (e.response?.status) {
          case 400:
            dispatch(
              changeErr("Token inválido ou expirado.")
            );
            break;
          case 404:
            dispatch(changeErr("Token inválido ou expirado."));
            break;
          case 422:
            dispatch(
              changeErr("A nova senha não atende aos requisitos de segurança. Por favor, escolha uma senha mais forte.")
            );
            break;
          case 409:
            dispatch(
              changeErr("A nova senha não pode ser igual às últimas 5 senhas utilizadas. Por favor, escolha uma senha diferente.")
            );
            break;
          case 500:
            dispatch(
              changeErr(
                "Não foi possível processar sua solicitação. Tente novamente mais tarde."
              )
            );
            break;
          default:
            dispatch(
              changeErr(
                "Desculpe, os servidores estão em manutenção no momento. Em algumas horas iremos retomar as atividades"
              )
            );
        }
        throw e;
      });
  };
}
